export default {
  'v-button': require('./YmButton'),
  'v-checkbox': require('./YmCheckbox'),
  'v-date': require('./YmDate'),
  'v-editor': require('./YmEditor'),
  'v-layer': require('./YmLayer'),
  'v-loading': require('./YmLoading'),
  'v-pager': require('./YmPager'),
  'v-radio': require('./YmRadio'),
  'v-select': require('./YmSelect'),
  'v-switch': require('./YmSwitch'),
  'v-table': require('./YmTable'),
  'v-upload': require('./YmUpload'),
  'v-tab': require('./YmTab'),
  'v-input-txt': require('./YmInputTxt'),
  'v-icon': require('./YmIcon')
}



// WEBPACK FOOTER //
// ./src/components/index.js